import React from 'react'

import Header from '@components/layout/header'
import ButtonComponent from '@components/button/button'
import { Container, Title, Message, BoxInformation, Main } from './default-plan-style'

const Default = () => {
  const redirectSiteAberto = () => {
    window.open('https://aberto.com.br/#fale-conosco', '_blank')
  }

  return (
    <Container>
      <Header />
      <Main>
        <BoxInformation>
          <Title> Conheça nossos planos </Title>
          <Message>
            Temos planos que com certeza se enquadram nas suas necessidades. <br />
            Preencha o nosso formulário para que possamos entrar em contato e apresentar nossas opções.
          </Message>
          <ButtonComponent theme="primary" onClick={redirectSiteAberto}>
            Entrar em contato
          </ButtonComponent>
        </BoxInformation>
      </Main>
    </Container>
  )
}

export default Default
